export const CERCA_FERMATA = 'CERCA_FERMATA'